export interface DirectSearchResponse {
    error?: DirectSearchError;
    result: DirectSearchResult | null;
}

export interface DirectSearchError {
    type: string;
    message: string;
}

export interface DirectSearchResult {
    redirectUrl: string;
}
